import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useCreateFeideWhitelist = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ feideId, description, autoImportChildren, autoImportParents }) =>
      authAPI.createFeideWhitelist(feideId, description, autoImportChildren, autoImportParents),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["feideWhitelists"]);
      },
    }
  );
};
